module.exports = __webpack_public_path__ + "img/CRT_P2_Sword-003.6d05c295.png";